module.exports = __webpack_public_path__ + "static/media/speech_09.0cffa9bf.png";